var cov_2mddoye40y = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Input/Group.tsx",
      hash = "6fb15d17b31309254b1efde3d814f1775dc60048",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Input/Group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 52
        },
        end: {
          line: 5,
          column: 57
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 11,
          column: 4
        }
      },
      "2": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 9,
          column: 5
        }
      },
      "3": {
        start: {
          line: 8,
          column: 6
        },
        end: {
          line: 8,
          column: 41
        }
      },
      "4": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 37
        }
      }
    },
    fnMap: {
      "0": {
        name: "Group",
        decl: {
          start: {
            line: 4,
            column: 9
          },
          end: {
            line: 4,
            column: 14
          }
        },
        loc: {
          start: {
            line: 4,
            column: 39
          },
          end: {
            line: 12,
            column: 1
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 40
          },
          end: {
            line: 6,
            column: 41
          }
        },
        loc: {
          start: {
            line: 6,
            column: 74
          },
          end: {
            line: 11,
            column: 3
          }
        },
        line: 6
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 9,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 9,
            column: 5
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 9,
            column: 5
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Input/Group.tsx";
import React, { Children, cloneElement } from 'react';

function Group(props) {
  var _this = this;

  cov_2mddoye40y.f[0]++;

  var _ref = (cov_2mddoye40y.s[0]++, props),
      children = _ref.children,
      style = _ref.style,
      inputFocus = _ref.inputFocus,
      other = _objectWithoutProperties(_ref, ["children", "style", "inputFocus"]);

  cov_2mddoye40y.s[1]++;
  return Children.toArray(children).map(function (child, i) {
    cov_2mddoye40y.f[1]++;
    cov_2mddoye40y.s[2]++;

    if (typeof child === 'string') {
      cov_2mddoye40y.b[0][0]++;
      cov_2mddoye40y.s[3]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: i,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 8,
            columnNumber: 14
          }
        }, child)
      );
    } else {
      cov_2mddoye40y.b[0][1]++;
    }

    cov_2mddoye40y.s[4]++;
    return (
      /*#__PURE__*/
      cloneElement(child, other)
    );
  });
}

export default Group;